import { render, staticRenderFns } from "./MoverNotasHistorico.vue?vue&type=template&id=f293fea0"
import script from "./MoverNotasHistorico.vue?vue&type=script&lang=js"
export * from "./MoverNotasHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports